import { render, staticRenderFns } from "./VideoReView.vue?vue&type=template&id=6910b24c&scoped=true"
import script from "./VideoReView.vue?vue&type=script&lang=js"
export * from "./VideoReView.vue?vue&type=script&lang=js"
import style0 from "./VideoReView.vue?vue&type=style&index=0&id=6910b24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910b24c",
  null
  
)

export default component.exports